export const BIRD_SAFE_NAME_CONSTANT = [
    '51205',
    '51767',
    '51777',
]